import { DateField, DateFieldProps, useLocaleState } from "react-admin";

export const LocalizedDateField = (props: DateFieldProps) => {
  const [locale] = useLocaleState();
  return <DateField {...props} locales={locale} />;
};
